var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_80",
    "data-name": "Groupe 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18.5,
    viewBox: "0 0 18.5 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M6,18.828V11.945a1.543,1.543,0,0,1,.686-1.283l5.4-3.6a1.537,1.537,0,0,1,1.711,0l5.4,3.6a1.543,1.543,0,0,1,.686,1.283v6.884M6,18.828A1.541,1.541,0,0,0,7.542,20.37H18.333a1.541,1.541,0,0,0,1.542-1.542M6,18.828l5.2-3.469m8.672,3.469-5.2-3.469M6,11.891l5.2,3.469m8.672-3.469-5.2,3.469m0,0-.879.586a1.537,1.537,0,0,1-1.711,0l-.879-.586",
    transform: "translate(-3.688 -4.182)",
    fill: "none",
    stroke: "#005151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M0,0H18.5V18.5H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMess);
export default __webpack_public_path__ + "static/media/mess.9014577392b85f9c0a200b7f7efa44fe.svg";
export { ForwardRef as ReactComponent };